import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumnTemplate from "./AbstractPeriodColumnTemplate.js";
import RollingPeriodColumn from "../../reports/columns/RollingPeriodColumn.js";

/**
 * Rolling period column template.
 *
 * Display the accumulated value rolling back N months (default to 12).
 *
 * @param {number} [spec.numberOfMonths] - Number of months to accumulate.
 */
export default class RollingPeriodColumnTemplate extends AbstractPeriodColumnTemplate {
	constructor({ numberOfMonths = 12 }) {
		super(...arguments);
		this._numberOfMonths = numberOfMonths;
		this._periodTemplate.setPeriodType("Month");
	}

	canEditPeriodTemplateType() {
		return false;
	}

	getNumberOfMonths() {
		return this._numberOfMonths;
	}

	setNumberOfMonths(numberOfMonths) {
		this._numberOfMonths = numberOfMonths;
	}

	accept(visitor) {
		return visitor.visitRollingPeriodColumnTemplate(this);
	}

	_instanceClass() {
		return RollingPeriodColumn;
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);

		spec.numberOfMonths = this._numberOfMonths;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.numberOfMonths = this._numberOfMonths;

		return properties;
	}

	static getLabel() {
		return _("Rolling period");
	}

	static getType() {
		return "RollingPeriodColumnTemplate";
	}
}
